export default "__VITE_ASSET__$HTzIc$q__"